import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions, URLSearchParams } from "@angular/http";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { analyzeAndValidateNgModules, Type } from "@angular/compiler";
import { map } from "rxjs/operators";
import * as $ from "jquery";

@Injectable({
  providedIn: "root"
})
export class ApiService {
  BaseURL: string = "https://pricingapi.rxhacker.com/api/v2/";
  BaseURL1: string = "https://pricingapi.rxhacker.com/api/v3/";

  /* newsletter email save to google sheet functionality */
  googleSheetApi =
    "https://script.google.com/macros/s/AKfycbzZKapInrPeLM9DG8JSChDkO7L3UdBQQwwOunrauCnQGBt67PFB/exec";


  // SendGrid Implementation
  verifyEmail(email, fname, lname, groupnumber?, deeplink?) {
    const headers = new Headers();
    headers.append("authorization", "Bearer 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");
    headers.append("Content-Type", "application/json");
    let body = { "list_ids": ["508dfc01-28a3-4aae-a6ec-5b8bda699478"], "contacts": [{ "alternate_emails": [], "email": email, "first_name": fname, "last_name": lname, "custom_fields": { "w5_T": groupnumber, "w4_T": deeplink } }] }
    // const body = new URLSearchParams();
    // body.set("filters[email]", email);
    // body.set("list_ids", "a3950689-86d9-4513-bcb8-964b177042e0");
    return this.http.put(
      "https://api.sendgrid.com/v3/marketing/contacts",
      body,
      { headers: headers }
    );
  }
  addtocontact(email, fname, lname, groupnumber?, deeplink?) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {"fname":fname,"lname":lname,"email":email,"groupnumber":groupnumber,"deeplink":deeplink,"memberid":window.localStorage.getItem('UserCharId')}
    // const body = new URLSearchParams();
    // body.set("filters[email]", email);
    // body.set("list_ids", "a3950689-86d9-4513-bcb8-964b177042e0");
    return this.http.post(
      "https://cors.23byt.es/"+this.BaseURL1+"subscribe",
      body,
      { headers: headers }
    );
  }

  addToMailingList(email, fname, lname, groupnumber?, deeplink?) {
    const headers = new Headers();
    headers.append("authorization", "Bearer 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");
    headers.append("Content-Type", "application/json");

    let no_deeplink = {
      "first_name": fname,
      "last_name": lname,
      "w4_T": null,
      "w5_T": groupnumber,
      "playstore": 'https://play.google.com/store/apps/details?id=com.firebase.rxhacker&hl=en_IN',
      "appstore": 'https://apps.apple.com/us/app/rxhacker/id1450904899',
      "member_id": '100-4542'
    }

    let has_deeplink = {
      "first_name": fname,
      "last_name": lname,
      "w4_T": deeplink,
      "w5_T": groupnumber,
      "member_id": '100-4542'
    }
    let body = {
      "personalizations": [
        {
          "to": [
            {
              "email": email,
              "name": fname
            }
          ],
          "dynamic_template_data": !!deeplink ? has_deeplink : no_deeplink
        }
      ],
      "from": {
        "email": "info@nulifespanrx.com",
        "name": "NuLifeSpan Rx"
      },
      "template_id": "d-67cfb18c2bca4140ba2e6a10a7536bb8"
    }
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  // SaveDeeplink(email, fname, lname, groupnumber?, deeplink?) {
  //   console.log("running SaveDeeplink");

  //   let headers = new Headers();
  //   headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8');
  //   return this.http.post(this.BaseURL2 + 'savedl', 'Fname=' + fname + '&Lname=' + lname + '&Email=' + email + '&Gn=' + groupnumber + '&DeepLink=' + deeplink + '&UserAgent=WebApp',
  //     { headers: headers });
  // }
  senddownloadlink(email) {
    const headers = new Headers();
    let dl = window.localStorage.getItem("DeepLinkURL");
    headers.append("authorization", "Bearer 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");
    headers.append("Content-Type", "application/json");
    let body = {
      "personalizations": [
        {
          "to": [
            {
              "email": email,
              "name": ""
            }
          ],
          dynamic_template_data: {
            link: !!dl ? dl : "https://bit.ly/RxHacker"
          }
        }
      ],
      "from": {
        "email": "info@nulifespanrx.com",
        "name": "NuLifeSpan Rx"
      },
      "template_id": "d-aebc0ed5f61149e894a0d2f38573fa4f"
    }
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  senddownloadlinkToEmail(email) {
    const headers = new Headers();
    let dl = window.localStorage.getItem("DeepLinkURL");
    headers.append("Content-Type", "application/json");
    let body = {"name":"","email":email,"message":""}
    return this.http.post(
      "https://cors.23byt.es/"+this.BaseURL1+"downloadlink",
      body,
      { headers: headers }
    );
  }

  SaveDeeplink(email, fname, lname, groupnumber, deeplink) {
    console.log("running SaveDeeplink");
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL + 'savedl', 'Fname=' + fname + '&Lname=' + lname + '&Email=' + email + '&Gn=' + groupnumber + '&DeepLink=' + deeplink + '&UserAgent=Web',
      { headers: headers });
  }
  getpharmacycarousel(zipcode) {
    // console.log("running SaveDeeplink");
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL1 + 'carouselpharmacies', 'ZipCode=' + zipcode,
      { headers: headers });
  }
  googlegeneric(bin, pcn, group, memberid) {
    const headers = new Headers();
    let dl = window.localStorage.getItem("DeepLinkURL");
    headers.append("Content-Type", "application/json");
    let body = {"bin":bin, "pcn":pcn, "group":group, "memberid":memberid, "appname":"nulifespanrx"}
    return this.http.post(
      "https://cors.23byt.es/https://passes.23byt.es/api/v1/pass/google_generic_pass",
      body,
      { headers: headers }
    );
  }
 applegeneric(bin, pcn, group, memberid) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {"bin":bin, "pcn":pcn, "group":group, "memberid":memberid, "appname":"nulifespanrx"}
    return this.http.post(
      "https://cors.23byt.es/https://passes.23byt.es/api/v1/pass/apple_generic_pass",
      body,
      { headers: headers }
    );
  }
  GetPhoneNoValidate(PhoneNumber) {
    let baseurlbackoffice = location.host == 'nulifespanrx.com' || location.host == 'www.nulifespanrx.com' ? 'https://backoffice.nulifespanrx.com' : 'https://dev-backoffice.nulifespanrx.com'
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {"PhoneNumber":PhoneNumber}
    return this.http.post(
      "https://cors.23byt.es/"+baseurlbackoffice+"/api/Account/GetPhoneNoValidate",
      body,
      { headers: headers }
    );
  }
  checkavailability(Phone, Email, UserName, IsUserName) {
    let baseurlbackoffice = location.host == 'nulifespanrx.com' || location.host == 'www.nulifespanrx.com' || location.host == 'staging.nulifespanrx.com' || location.host == 'test.nulifespanrx.com' ? 'https://backoffice.nulifespanrx.com' : 'https://dev-backoffice.nulifespanrx.com'
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {"Phone":Phone, "Email":Email, "UserName":UserName, "IsUserName":IsUserName}
    return this.http.post(
      "https://cors.23byt.es/"+baseurlbackoffice+"/api/Account/checkavailability",
      body,
      { headers: headers }
    );
  }
  getCookie(name) {
    return (name = (document.cookie + ';').match(new RegExp(name + '=.*;'))) && name[0].split(/=|;/)[1];
  }
  
  createuser(Fname, Lname, Phone, Email, UserName, Password, SignupLink) {
    let cookiename = this.getCookie('mainframe_url_clb')    
    let baseurlbackoffice = location.host == 'nulifespanrx.com' || location.host == 'www.nulifespanrx.com' || location.host == 'staging.nulifespanrx.com' || location.host == 'test.nulifespanrx.com' ? 'https://backoffice.nulifespanrx.com' : 'https://dev-backoffice.nulifespanrx.com';
    if(cookiename != null) {
      SignupLink = cookiename
    }
    let domainurl = location.host;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {"Fname":Fname, "Lname":Lname, "Phone":Phone, "Email":Email, "UserName":UserName, "Password":Password, "SignupLink":domainurl, "ObjectUid":"", "UserType":"consumer", "Url":SignupLink}
    return this.http.post(
      "https://cors.23byt.es/"+baseurlbackoffice+"/api/Consumer/CreateAccount_consumer",
      body,
      { headers: headers }
    );
  }
  SendChromeemail(link, email) {
    let baseurlbackoffice = location.host == 'nulifespanrx.com' || location.host == 'www.nulifespanrx.com' ? 'https://backoffice.nulifespanrx.com' : 'https://dev-backoffice.nulifespanrx.com'
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    let body = {  "Apple_passlink":link, "Email":email}
    return this.http.post(
      "https://cors.23byt.es/"+baseurlbackoffice+"/api/Consumer/Iphone_Chrome_Email",
      body,
      { headers: headers }
    );
  }
  checkusername(username) {
    let baseurlbackoffice = location.host == 'nulifespanrx.com' || location.host == 'www.nulifespanrx.com' ? 'https://backoffice.nulifespanrx.com' : 'https://dev-backoffice.nulifespanrx.com'
    const headers = new Headers();
    let dl = window.localStorage.getItem("DeepLinkURL");
    headers.append("Content-Type", "application/json");
    let body = {"username":username}
    return this.http.post(
      "https://cors.23byt.es/"+baseurlbackoffice+"/api/Account/GetUserNameFilter",
      body,
      { headers: headers }
    );
  }

  googleSheetData() {
    var googleSheetForm = $("#submit-to-google-sheet");
    var jqxhr = $.ajax({
      url: this.googleSheetApi,
      method: "GET",
      dataType: "json",
      data: googleSheetForm.serialize()
    });
  }

  constructor(public http1: HttpClient, public http: Http) { }

  SearchDrugList(searchtext) {
    var Encode_DrugName = encodeURIComponent(searchtext);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL + "searchdrug",
      "stext=" + Encode_DrugName,
      {
        headers: headers
      }
    );
  }
  GetPopularDrug() {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL + "populardrug", "DrugName=" + "test", {
      headers: headers
    });
  }
  GetDrugDetails(DrugName) {
    var Encode_DrugName = encodeURIComponent(DrugName);
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(
      this.BaseURL + "drugcomponents",
      "DrugName=" + Encode_DrugName,
      { headers: headers }
    );
  }
  addActiveContact(email, first_name, last_name, tags) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append("No-Auth", "True");
    const body = new URLSearchParams();
    body.set("email", email);
    body.set("first_name", first_name);
    body.set("last_name", last_name);
    body.set("tags", tags);
    // headers.append(
    //   "Content-Type",
    //   "application/x-www-form-urlencoded; charset=utf-8"
    // );
    return this.http.post(
      "https://cors.23byt.es/https://valpaksi.api-us1.com/admin/api.php?api_action=contact_add&api_key=84747226ebba49bee437d9460570432594890916bcd02276a010033c5589579274b27e15&api_output=json",
      body.toString(),
      { headers: headers }
    );
  }
  sendEmail(email, name, Message) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      "Bearer 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"
    );
    let body = {
      from: {
        email: email,
        name: name
      },
      personalizations: [
        {
          to: [
            {
              email: "info@nulifespanrx.com"
              // email: "manoj@23byt.es"
            }
          ],
          dynamic_template_data: {
            name: name,
            email: email,
            message: Message
          }
        }
      ],
      template_id: "d-fa1aa59d6ce94e03851509cc8b0510bf"
    };
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  sendEmailContact(email, name, Message) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    
    let body = {
      "name":name,"email":email,"message":Message
    };
    return this.http.post(
      "https://cors.23byt.es/"+ this.BaseURL1+"contact",
      body,
      { headers: headers }
    );
  }
  sendEmailUser(email, name, Message) {
    
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      "Bearer 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"
    );
    let body = {
      from: {
        email: email,
        name: name
      },
      personalizations: [
        {
          to: [
            {
              email: email
            }
          ],
          dynamic_template_data: {
            name: name,
            email: email,
            message: Message
          }
        }
      ],
      template_id: "d-fa1aa59d6ce94e03851509cc8b0510bf"
    };
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  sendHelp(email, name, Message) {
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/json");
    headers.append(
      "Authorization",
      // "Bearer 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"
      "Bearer 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"
    );
    let body = {
      from: {
        email: email,
        name: name
      },
      personalizations: [
        {
          to: [
            {
              email: "info@nulifespanrx.com"
              // email: "narayan@23byt.es"
              // email: "abhay@23byt.es"
            }
          ],
          dynamic_template_data: {
            receipt: true,
            name: name,
            email: email,
            Message: Message
          }
        }
      ],
      template_id: "d-67cfb18c2bca4140ba2e6a10a7536bb8"
    };
    // body.set("email", email);
    // body.set("first_name", first_name);
    // body.set("last_name", last_name);
    // body.set("tags", tags);
    return this.http.post(
      "https://cors.23byt.es/https://api.sendgrid.com/v3/mail/send",
      body,
      { headers: headers }
    );
  }
  sendSms(mobileno, deeplink?) {
    let dl = window.localStorage.getItem("DeepLinkURL");
    var output = mobileno.replace(/\W+/g, "");
    output = "+1" + output;
    const headers = new Headers();
    headers.append("Accept", "*/*");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append(
      "Authorization",
      "Basic " +
      btoa(
        "ACb8d8e490b15e18cdc6de483385f77234: 87c58ab499c23c69a4fd4e230d898187"
      )
    );
    const body = new URLSearchParams();
    body.set("To", output);
    body.set(
      "Body",
      "Please use the link below to download NuLifeSpan Rx and start saving now! \n \n " + (!!dl ? dl : "https://bit.ly/RxHacker")
    );
    body.set("From", "(469) 804-5822");
    // headers.append(
    //   "Content-Type",
    //   "application/x-www-form-urlencoded; charset=utf-8"
    // );
    return this.http.post(
      "https://cors.23byt.es/https://api.twilio.com/2010-04-01/Accounts/ACb8d8e490b15e18cdc6de483385f77234/Messages.json",
      body.toString(),
      { headers: headers }
    );
  }
  GetLatestPrice(npi: string, ndccode: string, zipcode: string, ActualQuantity: string) {
    let headers = new Headers();
    headers.append(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    return this.http.post(this.BaseURL1 + 'pharmacyprice', 'NPI=' + npi + '&ZipCode=' + zipcode + '&Quant=' + ActualQuantity + '&NDCCode=' + ndccode,
      { headers: headers });
  }
}